
export function FullPrivacyPage() {
    /* this is fetched from the legal folder, which is copied to
     * to nginx root folder when the docker image is build for this
     * code base. */
    window.location.href = 'https://echobankagent.com/privacy.html';
    return null;
}


export function DisclaimerPage() {
    /* this is fetched from the legal folder, which is copied to
     * to nginx root folder when the docker image is build for this
     * code base. */
    window.location.href = 'https://echobankagent.com/disclaimer.html';
    return null;
}


export function TermsOfUsePage() {
    /* this is fetched from the legal folder, which is copied to
     * to nginx root folder when the docker image is build for this
     * code base. */
    window.location.href = 'https://echobankagent.com/terms.html';
    return null;
}